import { ApiTimeoutModel } from ".";

export const timeoutOverrides: ApiTimeoutModel[] = [
    { Url: "api/ODLPortal/PutTarget/", Timeout: 60 * 1000, Match: "prefix" },
    { Url: "api/v2/m365opscenter/certificatedashboard/certificates/data-export", Timeout: 180 * 1000 },
    { Url: "api/v2/m365opscenter/certificatedashboard/certificates/instances/data-export", Timeout: 180 * 1000 },
    { Url: "api/deploymentapi/response/v1/whereismyfix/export", Timeout: 90 * 1000 },
    { Url: "cloud-scope/api/v1/features/export", Timeout: 180 * 1000 },
    { Url: "cloud-scope/api/v1/features/export/services", Timeout: 180 * 1000 },
    { Url: "cloud-scope/api/v1/features/export/configs", Timeout: 180 * 1000 },
    { Url: "m365opscenter-gateway/microsoft-digital-escort/cts-esm-integration/api/escortrdplauncher/mdeescortrdplauncher.exe", Timeout: 60 * 1000 },
    { Url: "mpa/api/eligibility/definitionslim", Timeout: 30 * 1000 },
    { Url: "mpa/api/workload/eligibilityv2", Timeout: 200 * 1000 },
    { Url: "mpa/api/workload/eligibility", Timeout: 200 * 1000 },
    { Url: "mpa/api/approval", Timeout: 30 * 1000 },
    { Url: "mpa/api/approval/approve", Timeout: 30 * 1000 },
    { Url: "mpa/api/approval/deny", Timeout: 30 * 1000 },
    { Url: "mpa/api/eligibility/geteligibilitiesicanapprove", Timeout: 30 * 1000 }
];
